import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { doFilteringSearchToApi, fetchCollectionProduct, getRecommendedProduct, getAdditionalPage } from '../../actions/productAction'
import classNames from 'classnames';
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import { convertToRupiah, parseKeyword, categoryURL } from '../../utils';
import { getQueryParamsUrl } from "../../helpers/url";
import ColorPicker from './ColorPicker';
import CheckboxBrands from './CheckboxBrands';
import { textValue, categorySearch, categoryURLSearchPage, sneakersCondition, sneakersConditionValue, genderSearchPage, categoryText, sneakersConditionUrl, sneakersConditionKey } from '../../utils/Helpers';
import { withRouter } from "react-router-dom";
import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import { getCollectionList } from "../../actions/kafairAction"
import fireIcon from "../../images/fire-product.png"
import expressShippingIcon from "../../images/express-shipping.png";
import DrawerBack from "../../images/drawerBack.png"
import ReactLoading from "react-loading";
import { getCategoryName } from 'Pages/Home/Helper/Formatter';
import { CATEGORY_LIST, SNEAKERS_CONDITION, GENDER_LIST, SNEAKERS_CONDITION_LUXURY, SNEAKERS_CONDITION_ONLY } from './Resources/Data';

/*
type Funct = (any:any, any2:any, any3:any) => void
type Props = {
  dataProduct:Object,
  dataFilter:Object, 
  doFilteringSearchToApi:Funct,
  history:Object,
  match:Object,
}
type State = {
  activeSize: string,
  selectedBrands: Array<number>,
  selectedSizes: Object,
  sneakers_condition:string  
}
*/

const styles = {
  click: {
    cursor: 'pointer'
  }
}

const PER_PAGE_DEFAULT = 52;

const SizeButton = ({ data, selectSize, isSelectedSize, getSizeButtonClass }) => {
  return (
    <Row className="size-row">
      {
        data.map(d => {
          return (
            <Col key={d.id} className="size-column">
              {/* <Button block className={classNames("flat spacer bolder small-button", this.getSizeButtonClass(size.id))} onClick={()=>this.selectSize(size)}>{size.US}</Button> */}
              <Button
                key={d.id}
                onClick={() => selectSize(d)}
                active={() => isSelectedSize(d.id)}
              // className={classNames("flat spacer bolder small-button", getSizeButtonClass(d.id))}
              >
                {d.US}
              </Button>
            </Col>
          )
        })
      }
    </Row>
  )
}

const Loader: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ marginTop: 16, display: isVisible ? 'flex' : 'none' }}
    >
      <Col>
        <ReactLoading type={'spin'} height={50} width={50} color={'#159953'} />
      </Col>
    </Row>
  );
};

class FilterDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSize: 'maleSizes',
      activeApparelsSize: 'topSizes',
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: [],
        apparelSizes: [],
      },
      userCurrency: {
        currency: 'IDR',
        ratio: 1
      },
      endPrice: '',
      startPrice: '',
      isBrandExpanded: false,
      isChildBrandExpanded: false,
      isSizeExpanded: false,
      isConditionExpanded: false,
      isPriceExpanded: false,
      sneakers_condition: '',
      sex: '',
      color: '',
      searchCategory: '',
      _activeTabSize: 1,
      // collectionButton: '',
      isFetchingBrands: false,
      isFetchingSize: true,
    };
    this.handleFilter = this.handleFilter.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.isSelectedSize = this.isSelectedSize.bind(this);
  }

  componentDidMount() {
    let { startPrice, endPrice, searchCategory } = this.props;
    const { isHotProductsPage, isMostPopularPage, isBestSellingPage } = this.props;
    this.setState({ startPrice, endPrice, searchCategory });

    // Handle for default selected filters
    const params = getQueryParamsUrl(this.props.history.location.search);
    const { brands, sneakersCondition, colours, sex, sizes, sizeTypes, sizeId, sizeAlias } = params;

    const filteredBrands = brands ? brands : "";
    if (filteredBrands) {
      const brands = filteredBrands.split(',');
      (async () => {
        for (let indexBrand = 0; indexBrand < brands.length;) {
          await this.selectBrand(parseInt(brands[indexBrand]));
          indexBrand++;
        }
      })();
    }
    if (sneakersCondition) {
      this.setState({ sneakers_condition: sneakersCondition });
    }
    if (colours) {
      this.setState({ color: colours });
    }
    if (sex) {
      this.setState({ sex })
    }
    // if (sizes && sizeTypes && sizeId) {
    //   const sizeArray = sizes.split(',');
    //   const sizeTypesArray = sizeTypes.split(',');
    //   const sizeIdArray = sizeId.split(',');
    //   const sizeAliasArray = sizeAlias?.split(',');
    // (async () => {
    //   for (let indexSize = 0; indexSize < sizeArray.length;) {
    //     const sizeObject = {
    //       id: parseInt(sizeIdArray[indexSize]),
    //       sex: sizeTypesArray[indexSize],
    //       US: sizeArray[indexSize],
    //       alias: sizeAliasArray && sizeAliasArray.length ? sizeAliasArray[indexSize] : '',
    //     };
    //     await this.selectSize(sizeObject);
    //     indexSize++;
    //   }
    // })();
    // }

    if (isHotProductsPage || isMostPopularPage || isBestSellingPage) {
      const { path } = this.props.match;
      const slug = path.slice(11);
      if (path) {
        this.setState({ collectionButton: slug })
      }
    }

    this.getListMadeIndo();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { dataAuth } = this.props
    const params = getQueryParamsUrl(this.props.history.location.search);
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.props;
    if (dataAuth.isLogged && dataAuth.userCurrency.isFetch !== prevProps.dataAuth.userCurrency.isFetch) {
      this.setState({ userCurrency: dataAuth.userCurrency })
    }

    if (prevProps.isOpen !== this.props.isOpen) {
      const { sneakers_condition, activeSize, activeApparelsSize, selectedBrands, selectedSizes: { maleSizes, femaleSizes, kidSizes, apparelSizes }, startPrice, endPrice, sex, color, searchCategory, collectionButton } = this.state;
      const category = this.props.match.params.category;

      //CATEGORY FOR API REQUEST
      const newCategory = ["streetwear", "fashion", "apparel"].includes(category) ? "apparels" : ["luxury", "handbags"].includes(category) ? "handbags" : ["lifestyle", "toys", "electronics-collectibles"].includes(category) ? "lifestyles" : category;
      const queryCategory = {
        params: {
          category: newCategory
        }
      }

      if (!this.props.isOpen) {
        this.setState({
          selectedSizes: {
            maleSizes: [],
            femaleSizes: [],
            kidSizes: [],
            apparelSizes: [],
          },
          isFetchingSize: true,
        });
      }

      if (this.props.isOpen) {
        if (isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage) {
          this.setState({
            searchCategory: categoryURL(params.category),
          });
        }
        if (!this.props.isCollectionPage) {
          this.props.getAllBrands(queryCategory);
        }
        this.fetchSize(newCategory);

        // SIZE FILTER RE SELECTED HANDLER
        const { sizes = "", sizeTypes = "", sizeId = "", sizeAlias = "" } = params;
        if (sizes && sizeTypes && sizeId) {

          const sizeArray = sizes.split(',');
          const sizeTypesArray = sizeTypes.split(',');
          const sizeIdArray = sizeId.split(',');
          const sizeAliasArray = sizeAlias?.split(',');
          (async () => {
            for (let indexSize = 0; indexSize < sizeArray.length;) {
              const sizeObject = {
                id: parseInt(sizeIdArray[indexSize]),
                sex: sizeTypesArray[indexSize],
                US: sizeArray[indexSize],
                alias: sizeAliasArray && sizeAliasArray.length ? sizeAliasArray[indexSize] : '',
              };
              await this.selectSize(sizeObject, true);
              indexSize++;
              if (indexSize === sizeArray.length) {
                this.setState({
                  isFetchingSize: false,
                })
              }
            }
          })();
        } else {
          setTimeout(() => {
            this.setState({
              isFetchingSize: false,
            });
          }, 1000);
        }
      }

      // BRANDS FILTER RE SELECTED HANDLER
      if (this.props.selectedBrands) {
        this.setState({ selectedBrands: this.props.selectedBrands });
      }

      const { path } = this.props.match;
      const slug = path && path.slice(11);

      if (!isHotProductsAllCategoryPage && !isTrendingPage && !isBestSellingAllCategoryPage && !isPriceDropPage) {
        this.setState({
          sneakers_condition: params.sneakersCondition ? params.sneakersCondition : "",
          startPrice: params.startPrice ? params.startPrice : "",
          endPrice: params.endPrice ? params.endPrice : "",
          sex: params.sex ? params.sex : "",
          color: params.colours ? params.colours : "",
          searchCategory: category ? category : "",
        });
      } else {
        this.setState({
          sneakers_condition: params.sneakersCondition ? params.sneakersCondition : "",
          startPrice: params.startPrice ? params.startPrice : "",
          endPrice: params.endPrice ? params.endPrice : "",
          sex: params.sex ? params.sex : "",
          color: params.colours ? params.colours : "",
        });
      }
    }

    // Handle for updating the filter drawer to latest filter state based on parent component
    if (prevProps.selectedBrands !== this.props.selectedBrands) {
      this.setState({
        selectedBrands: this.props.selectedBrands,
      });
    }
    if (prevProps.sex !== this.props.sex) {
      this.setState({
        sex: this.props.sex,
      });
    }
    if (prevProps.sneakers_condition !== this.props.sneakers_condition) {
      this.setState({
        sneakers_condition: this.props.sneakers_condition,
      });
    }
    if (prevProps.selectedSizes !== this.props.selectedSizes) {
      this.setState({
        selectedSizes: this.props.selectedSizes,
      });
    }
    if ((prevProps.searchCategory !== this.props.searchCategory) && (!isHotProductsAllCategoryPage && !isTrendingPage && !isBestSellingAllCategoryPage && !isPriceDropPage)) {
      this.setState({
        searchCategory: this.props.searchCategory,
      });
    }
    if (prevProps.startPrice !== this.props.startPrice) {
      this.setState({
        startPrice: this.props.startPrice,
      });
    }
    if (prevProps.endPrice !== this.props.endPrice) {
      this.setState({
        endPrice: this.props.endPrice,
      });
    }
    if (prevProps.color !== this.props.color) {
      this.setState({
        color: this.props.color,
      });
    }

    if (prevState._activeTabSize !== this.state._activeTabSize) {
      const category = this.props.match.params.category;
      const newCategory = ["streetwear", "fashion", "apparel"].includes(category) ? "apparels" : category === "luxury" ? "handbags" : ["lifestyle", "toys", "electronics-collectibles"].includes(category) ? "lifestyles" : category;
      this.fetchSize(newCategory);
    }
  }

  fetchSize = (category) => {
    let sizeAlias, sizeValue;

    // for sneakers category
    if (category === 'sneakers') {
      sizeAlias = 'sex';
      switch (this.state._activeTabSize) {
        case 1:
          sizeValue = 'm';
          break;
        case 2:
          sizeValue = 'f';
          break;
        case 3:
          sizeValue = 'k,gs,p,it';
          break;
        default:
          sizeValue = '';
          break;
      }
    }

    // for apparel category
    if (category === 'apparels') {
      sizeAlias = 'alias';
      switch (this.state._activeTabSize) {
        case 1:
          sizeValue = 'top';
          break;
        case 2:
          sizeValue = 'bottom';
          break;
        case 3:
          sizeValue = 'others';
          break;
        default:
          sizeValue = '';
          break;
      }
    }

    const queryCategory = {
      params: {
        category: category,
        [sizeAlias]: sizeValue?.toUpperCase(),
      }
    }

    this.setState({
      isFetchingSize: true,
    }, () => {
      const fetchSizes = async () => {
        await this.props.getAllSizes(queryCategory);
        this.setState({
          isFetchingSize: false,
        });
      }
      fetchSizes();
    });
  };

  getListMadeIndo = () => {
    if (!this.props.isMadeIndonesia) return
    let payload = {
      availables: true,
      per_page: 11,
      page: 1,
    };

    this.props.getCollectionList('all', 'madeindonesia', payload, 'madeindonesia')
      .then((res) => res.data)
  }

  getBrandsByCategory = async () => {
    // const category = this.props.match.params.category;

    // await this.setState({
    //   searchCategory: category
    // })

    //CATEGORY FOR API REQUEST
    const newCategory = ["streetwear", "fashion", "apparel"].includes(this.state.searchCategory) ? "apparels" : this.state.searchCategory === "luxury" ? "handbags" : ["lifestyle", "toys", "electronics-collectibles"].includes(this.state.searchCategory) ? "lifestyles" : this.state.searchCategory;

    const queryCategory = {
      params: {
        category: newCategory
      }
    }

    this.props.getAllBrands(queryCategory);
    this.fetchSize(newCategory);
  }

  /* BRAND */
  selectBrand = async (brand) => {
    return new Promise((resolve) => {
      const currentBrands = this.state.selectedBrands ? this.state.selectedBrands : [];
      let filteredBrands = currentBrands.filter(selectedBrand => selectedBrand !== brand.slug)

      let newSelectedBrands = currentBrands.length === filteredBrands.length
        ? [...currentBrands, brand.slug]
        : filteredBrands;

      this.setState({ selectedBrands: newSelectedBrands }, () => {
        resolve(this.state.selectedBrands),
          () => this.applyFilter();
      });
    })
  }

  getBrandButtonClass = (brandId) => {
    const currentBrands = this.state.selectedBrands ? this.state.selectedBrands : [];
    return currentBrands.toString().indexOf(brandId) > -1
      ? 'btn-black'
      : 'btn-white'
  }

  onChangeHandler = (e) => {
    const key = e.target.name
    let val = e.target.value;
    if (isNaN(+val)) return;
    this.updateState(key, val);
  }

  // minPriceHandler = (e) => {
  //   let dataMinPrice = { ...this.props.minPrice}

  //   switch(e.target.name){
  //     case 'minPrice':
  //     dataMinPrice = e.target.value.replace(/[\. ,:-]+/g, '')

  //     default: null
  //   }

  //   this.setState({
  //     minPrice: parseInt(dataMinPrice)
  //   })
  // }

  // maxPriceHandler = (e) => {
  //   let dataMaxPrice = { ...this.props.maxPrice}

  //   switch(e.target.name){
  //     case 'maxPrice':
  //     dataMaxPrice = e.target.value.replace(/[\. ,:-]+/g, '')

  //     default: null
  //   }

  //   this.setState({
  //     maxPrice: parseInt(dataMaxPrice)
  //   })
  // }

  isSelected(selected) {
    const { selectedBrands } = this.state;
    const item = selectedBrands?.find((a) => a === selected.slug);
    return item !== undefined && item !== null;
  }

  isSelectedSize(selected, alias = "") {
    let activeSize = "";
    switch (selected.sex) {
      case "M":
        activeSize = "maleSizes";
        break;
      case "F":
        activeSize = "femaleSizes";
        break;
      case "K":
        activeSize = "kidSizes";
        break;
      case "U":
        activeSize = "apparelSizes";
        break;
      default:
        activeSize = "kidSizes";
        break;
    }
    const selectedSizes = this.state.selectedSizes[activeSize];
    const item =
      (selectedSizes.length > 0 && alias !== '') ?
        selectedSizes.find(
          (a) => a.id === selected.id && (a.alias !== '' ? a.alias === selected.alias : true)
        ) :
        selectedSizes.find((a) => a.id === selected.id);

    return item !== undefined && item !== null;
  }

  getButtonClass = (key, val) => {
    const queries = getQueryParamsUrl(this.props.history.location.search);
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.props;
    let value = (isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage) ? queries.category : this.state[key];

    if (this.state[key] === 'apparels') {
      value = 'apparel';
    } else if (this.state[key] === 'handbags') {
      value = 'luxury'
    } else if (this.state[key] === 'lifestyles') {
      value = 'electronics-collectibles'
    }
    return value === val ? 'btn-black' : 'btn-white'
  }

  updateState = (key, val, unselectable = false, callback = () => { }) => {
    if (!unselectable) {
      this.setState({ [key]: val }, callback);
    } else {
      if (this.state[key] === val && key === 'searchCategory') {
        this.setState({
          selectedSizes: {
            maleSizes: [],
            femaleSizes: [],
            kidSizes: [],
            apparelSizes: [],
          },
        });
      }
      this.setState({
        [key]: this.state[key] === val ? '' : val //clear if the value is already selected
      }, callback)
    }
  }

  afterUpdateCategory = (category) => {
    if (this.props.isHotProductsPage) {
      this.props.history.push(`/${categoryURL(category)}/hot-products`)
    }
    if (this.props.isMostPopularPage) {
      this.props.history.push(`/${categoryURL(category)}/most-popular`)
    }
    if (this.props.isBestSellingPage) {
      this.props.history.push(`/${categoryURL(category)}/best-selling`)
    }
  };

  /* SIZE */
  selectSize = (size, ignoreFilteredSize = false) => {
    return new Promise(resolve => {
      let { activeSize } = this.state;

      // CONDITION TO HANDLE RE SELECTED FILTER
      if (size.sex) {
        switch (size.sex) {
          case "M":
            activeSize = "maleSizes";
            break;
          case "F":
            activeSize = "femaleSizes";
            break;
          case "K":
            activeSize = "kidSizes";
            break;
          case "U":
            activeSize = "apparelSizes";
            break;
          default:
            activeSize = "kidSizes";
            break;
        }
      }

      let selectedSizes = this.state.selectedSizes[activeSize];
      const selectedSizeWithSameId = [...selectedSizes, size].filter(v => v.id === size.id);
      const selectedSizeWithSameIdAndSameAlias = [...selectedSizes, size].filter(v => v.id === size.id).filter(v => v.alias === size.alias);
      const differentAliasWithSameId = selectedSizeWithSameId.length > 1 ? selectedSizeWithSameId?.[0]?.alias !== selectedSizeWithSameId?.[1]?.alias : false;
      let filteredSizes = selectedSizes?.filter(selectedSize => selectedSize.id != size.id);

      let newSelectedSizes =
        selectedSizeWithSameId.length > 1 && !ignoreFilteredSize
          ? [...filteredSizes, ...selectedSizeWithSameId.filter(t => t.id !== selectedSizeWithSameId[0].id)]
          : selectedSizes && filteredSizes || (selectedSizes.length === filteredSizes.length && !ignoreFilteredSize)
            ? [...selectedSizes, size]
            : selectedSizeWithSameIdAndSameAlias.length > 1
              ? [...filteredSizes, ...selectedSizeWithSameId.filter(t => t.alias !== selectedSizeWithSameIdAndSameAlias[0].alias)]
              : (differentAliasWithSameId && activeSize === 'apparelSizes')
                ? [...filteredSizes, ...selectedSizeWithSameId]
                : filteredSizes;
      let newSelectedSizesState = {
        ...this.state.selectedSizes, [activeSize]: newSelectedSizes.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.id === value.id
          ))
        )
      };
      this.setState({
        selectedSizes: newSelectedSizesState
      }, () => {
        resolve(this.state.selectedSizes);
      });
    })
  }

  getSizeButtonClass = (sizeId) => {
    let { activeSize } = this.state
    let selectedSizes = this.state.selectedSizes[activeSize];
    return selectedSizes.find(size => size.id == sizeId)
      ? 'btn-black'
      : 'btn-white'
  }

  calculateSize = () => {
    let { maleSizes, femaleSizes, kidSizes, apparelSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes, ...apparelSizes];
    const sizesTypes = sizes.map(s => s.sex).join(",");
    const sizesAlias = sizes.map(s => s.alias).join(",");

    return sizes.length
      ? `sizes=${sizes.map(s => s.US).join(",")}&size_types=${sizesTypes}&sizeAlias=${sizesAlias}`
      : ''
  }

  getSizeIdHelper = () => {
    let { maleSizes, femaleSizes, kidSizes, apparelSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes, ...apparelSizes]

    return sizes.length
      ? `sizeId=${sizes.map(s => s.id).join(",")}&`
      : ''
  }

  dolarToRupiah = (price) => {
    return Math.round(parseFloat(price) / this.state.userCurrency.ratio)
  }

  handleFilter = () => {
    const { selected } = this.props.dataCategory;
    const { pathname } = this.props.history.location
    const { searchKeyword, caseSorting } = this.props.dataProduct;
    const { startPrice, endPrice, sneakers_condition, sex, color, searchCategory, activeSize, activeApparelsSize, selectedBrands, selectedSizes } = this.state;
    const params = getQueryParamsUrl(this.props.history.location.search);
    const searchKeywordFilter = params && params.keyword === undefined ? '' : params && params.keyword;
    const manipulate = searchKeywordFilter && searchKeywordFilter.trim().split(" ").join("+");
    const categoryURL = getCategoryName(searchCategory);

    const categoryParams = ["lifestyle", "toys", "electronics-collectibles"].includes(searchCategory) ? "lifestyles" : searchCategory;

    const newPathName = searchCategory && searchCategory !== 'all_category' ? `/search/${categoryURL}` : "/browse-all";

    const brands = this.state.selectedBrands?.join(",");
    const sizesParams = this.calculateSize();

    let startPriceCon = startPrice
    let endPriceCon = endPrice

    if ((startPrice || endPrice) && this.state.userCurrency.currency !== 'IDR') {
      startPriceCon = this.dolarToRupiah(startPrice)
      endPriceCon = this.dolarToRupiah(endPrice)
    }

    let filterQueries = '';
    let filterQueriesConverted = '';
    let queries = []
    if (params && params.keyword) queries.push({ keyword: 'keyword', value: manipulate })
    if (brands) queries.push({ keyword: 'brands', value: brands })
    if (sizesParams) queries.push({ keyword: '', value: `${sizesParams}&` })
    if (startPrice) queries.push({ keyword: 'start_price', value: startPrice })
    if (endPrice) queries.push({ keyword: 'end_price', value: endPrice })
    if (sneakers_condition) queries.push({ keyword: 'sneakers_condition', value: sneakers_condition })
    if (sizesParams) queries.push({ keyword: '', value: this.getSizeIdHelper() })
    if (sex) queries.push({ keyword: 'sex', value: sex })
    if (color) queries.push({ keyword: 'colours', value: color })

    // if (params && params.keyword) filterQueries += `keyword=${manipulate}&`
    // if (brands) filterQueries += `brands=${brands}&`
    // if (sizesParams) filterQueries += `${sizesParams}&`
    // if (startPrice) filterQueries += `start_price=${startPrice || 0}&`
    // if (endPrice) filterQueries += `end_price=${endPrice}&`
    // if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    // if (sizesParams) filterQueries += `${this.getSizeIdHelper()}&`
    // if (sex) filterQueries += `sex=${sex}&`
    // if (color) filterQueries += `colours=${color}`

    if (queries.length) {
      queries.map((q) => {
        if (q.keyword) {
          if (q.keyword === 'start_price' || q.keyword === 'end_price') {
            filterQueries += `${q.keyword}=${q.value}&`
            filterQueriesConverted += `${q.keyword}=${q.keyword === 'start_price' ? startPriceCon : endPriceCon}&`
          } else {
            filterQueries += `${q.keyword}=${q.value}&`
            filterQueriesConverted += `${q.keyword}=${q.value}&`
          }
        } else {
          filterQueries += q.value
          filterQueriesConverted += q.value
        }
      })
    }

    if (filterQueries.length || filterQueriesConverted.length) {
      if (filterQueries.charAt(filterQueries.length - 1) === '&') {
        filterQueries = filterQueries.substr(0, filterQueries.length - 1)
      }
      if (filterQueriesConverted.charAt(filterQueriesConverted.length - 1) === '&') {
        filterQueriesConverted = filterQueriesConverted.substr(0, filterQueriesConverted.length - 1)
      }
      filterQueries.replace('&&', '&')
      filterQueriesConverted.replace('&&', '&')
    }

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    if (filterQueries) {
      this.props.history.push({ pathname: newPathName, search: newFilterQueries });
    } else {
      this.props.history.push({ pathname: newPathName });
    }

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    let categoryFilter = categoryParams;
    if (categoryParams === 'streetwear' || categoryParams === 'fashion' || categoryParams === 'apparel') {
      categoryFilter = 'apparels';
    } else if (categoryParams === 'luxury') {
      categoryFilter = 'handbags';
    } else if (categoryParams === 'lifestyle' || categoryParams === 'toys' || categoryParams === 'electronics-collectibles') {
      categoryFilter = 'lifestyles';
    }

    const newFilterQueriesConverted = filterQueriesConverted.replace("express_shipping", "pre_verified");

    if (searchKeywordFilter.toUpperCase() === 'BROWSE+ALL' || searchKeywordFilter.toUpperCase() === 'BROWSE+ALL') {
      this.props.doFilteringSearchToApi(newFilterQueriesConverted, {
        params: {
          page: 1,
          availables: true,
          category: categoryFilter,
          per_page: PER_PAGE_DEFAULT,
          sort_by: caseSorting
        }
      }, '');
    } else {
      if (searchKeywordFilter === '') {
        this.props.doFilteringSearchToApi(newFilterQueriesConverted, {
          params: {
            page: 1,
            availables: true,
            category: categoryFilter,
            per_page: PER_PAGE_DEFAULT,
            sort_by: caseSorting
          }
        }, '');
      } else {
        this.props.doFilteringSearchToApi(newFilterQueriesConverted, {
          params: {
            page: 1,
            availables: true,
            category: categoryFilter,
            per_page: PER_PAGE_DEFAULT,
            sort_by: caseSorting
          }
        }, '');
      }
    }

    this.props.onSaveLastState(activeSize, activeApparelsSize, selectedBrands, selectedSizes, sneakers_condition, startPrice, endPrice, sex, color, searchCategory)
  }

  resetFilter = () => {
    if (this.props.categoryOnly) {
      this.props.history.push(this.props.history.location.pathname);
      this.props.onClose();
      return;
    }

    const { selected } = this.props.dataCategory;
    const { caseSorting } = this.props.dataProduct;
    const { isCollectionPage, isForYou } = this.props;
    const pathname = this.props.location && this.props.location.pathname;
    const isCategory = pathname.search(categoryURL(selected));

    this.setState({
      startPrice: "",
      endPrice: "",
      sneakers_condition: "",
      sex: "",
      color: "",
      brands: "",
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: [],
        apparelSizes: [],
      },
      selectedBrands: []
    }, () => {
      if (window.innerWidth <= 655) {
        this.props.onClose()
      }

      const newPathname = `/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`;

      const removeCategory = (isCategory > 0) ? `${newPathname}` : `${pathname}`;

      this.props.doFilteringSearchToApi('', {
        params: {
          page: 1,
          availables: true,
          category: isCollectionPage || isForYou ? selected : "",
          per_page: PER_PAGE_DEFAULT,
          sort_by: caseSorting
        }
      }, '')
      this.props.history.push({
        pathname: isCollectionPage ? removeCategory : `/browse-all`,
        search: ''
      })
    })
  }

  applyFilter = () => {
    if (this.props.isForYou) {
      this.handleForYouFilter();
    } else if (this.props.isCollectionPage) {
      this.handleCollectionFilter();
    } else if (this.props.isHotProductsPage || this.props.isHotProductsAllCategory) {
      this.handleHotProductsFilter();
    } else if (this.props.isMostPopularPage) {
      this.handleMostPopularFilter();
    } else if (this.props.isBestSellingAllCategoryPage || this.props.isBestSellingPage) {
      this.handleBestSellingFilter();
    } else {
      this.handleFilter();
    }
  }

  _renderNewCategory = () => {
    const { selected } = this.props.dataCategory;
    const { searchCategory } = this.state;
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.props;

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Category</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="condition-wrapper">
          <Row className="condition-sneaker">
            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("searchCategory", "sneakers"))} onClick={() => {
                if (this.props.isCollectionPage) {
                  location.replace(`/sneakers/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`)
                  return;
                }
                this.updateState("searchCategory", "sneakers", true, this.afterUpdateCategory('sneakers'));
              }}>Sneakers</Button>
            </div>

            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("searchCategory", "apparel"))} onClick={() => {
                if (this.props.isCollectionPage) {
                  location.replace(`/apparel/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`)
                  return;
                }
                this.updateState("searchCategory", "apparel", true, this.afterUpdateCategory('apparel'));
              }}>Apparel</Button>
            </div>

            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("searchCategory", "luxury"))} onClick={() => {
                if (this.props.isCollectionPage) {
                  location.replace(`/luxury/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`)
                  return;
                }
                this.updateState("searchCategory", "luxury", true, this.afterUpdateCategory('luxury'));
              }}>Luxury</Button>
            </div>
            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("searchCategory", "electronics-collectibles"))} onClick={() => {
                if (this.props.isCollectionPage) {
                  location.replace(`/electronics-collectibles/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`)
                  return;
                }
                this.updateState("searchCategory", "electronics-collectibles", true, this.afterUpdateCategory('electronics-collectibles'));
              }}>Electronics & Collectibles</Button>
            </div>
            {(isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage) ? null : <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("searchCategory", "madeindonesia"))} onClick={() => {
                if (this.props.isCollectionPage) {
                  location.replace(`/madeindonesia/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`)
                  return;
                }
                this.updateState("searchCategory", "madeindonesia", true)
              }}>MadeIndonesia</Button>
            </div>}
          </Row>
        </Col>
      </Row>
    )
  }

  _renderAllBrands = () => {
    const { category } = this.props.match.params

    return (
      <>
        {this._renderCategoryBrands()}
      </>
    )
  }

  _renderCategoryBrands = () => {
    let { brands } = this.props.dataFilter;
    let slicedBrands = brands.slice(0, 8);
    let allBrands = brands.slice(8, brands.length);

    return (
      <>
        <Row
          style={{ marginLeft: 0, alignSelf: "flex-start" }}
          onClick={() => this.props.updateState('isConditionExpanded', !this.props.isConditionExpanded)}>
          <Col md={10} xs={8} style={{ paddingLeft: 0 }}>
            <p className="title">Brands</p>
          </Col>
          <Col md={2} xs={4} className="dropdown-icon">
            <span className="dropdown-icon">
              <i className={this.props.isConditionExpanded ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
            </span>
          </Col>
        </Row>
        {
          this.state.isFetchingBrands ?
            <ReactLoading type={"spokes"} color={"#4a4a4a"} height={20} width={20} /> :
            <>
              <Row style={{ marginLeft: 0, alignSelf: "flex-start" }}>
                <Col xs={12} className="condition-wrapper">
                  {
                    slicedBrands.map(brand => (
                      <Col className="brand-button" key={brand.id}>
                        <label>
                          <input
                            key={brand.id}
                            type="checkbox"
                            name={brand.id}
                            value={this.state.selectedBrands}
                            checked={this.isSelected(brand)}
                            onChange={() => this.selectBrand(brand)} />
                          <span className="ka-radio-label"> </span>
                          <span className="ka-radio-text">{brand.title ? brand.title : brand.name}</span>
                        </label>
                      </Col>
                    ))
                  }
                </Col>
              </Row>
              {
                (!this.props.isConditionExpanded) ?
                  <Row style={{ marginLeft: 0, alignSelf: "flex-start" }}>
                    <Col xs={12} className="condition-wrapper">
                      <Row onClick={() => this.props.updateState('isConditionExpanded', !this.props.isConditionExpanded)} className="show-all-wrapper">
                        <Col style={{ padding: 0 }}>
                          <p className="sub-title" style={{ cursor: 'pointer' }}>Show All Brands</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  :
                  <Row style={{ marginLeft: 0, alignSelf: "flex-start" }}>
                    <Col xs={12} className="condition-wrapper">
                      {
                        allBrands.map(brand => (
                          <Col className="brand-button">
                            <label>
                              <input
                                key={brand.slug}
                                type="checkbox"
                                name={brand.slug}
                                value={this.state.selectedBrands}
                                checked={this.isSelected(brand)}
                                onChange={() => this.selectBrand(brand)} />
                              <span className="ka-radio-label"> </span>
                              <span className="ka-radio-text">{brand.title ? brand.title : brand.name}</span>
                            </label>
                          </Col>
                        ))
                      }
                    </Col>
                    <Col xs={12}>
                      <Row style={{ marginLeft: 0 }} onClick={() => this.props.updateState('isConditionExpanded', !this.props.isConditionExpanded)} style={styles.click}>
                        <Col style={{ padding: 0 }}>
                          <p className="sub-title">Show Less</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
              }
            </>
        }
      </>
    )
  }

  _renderNewConditions = () => {
    const { selected } = this.props.dataCategory;
    const { category } = this.props.match.params;

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Conditions</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="condition-wrapper">
          {
            selected === "handbags" || category === "luxury" ?
              <Row className="condition-sneaker">
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "express_shipping"))} onClick={() => this.updateState("sneakers_condition", "express_shipping", true)}>Express Shipping <KickImage src={expressShippingIcon} alt="express shipping" style={{ width: "8px", height: "12px" }} /></Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "new"))} onClick={() => this.updateState("sneakers_condition", "new", true)}>Brand New</Button>
                </div>

                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "pristine"))} onClick={() => this.updateState("sneakers_condition", "pristine", true)}>Pristine</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "good"))} onClick={() => this.updateState("sneakers_condition", "good", true)}>Good</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "well_used"))} onClick={() => this.updateState("sneakers_condition", "well_used", true)}>Well Used</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "like_new"))} onClick={() => this.updateState("sneakers_condition", "like_new", true)}>Like New</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "vintage"))} onClick={() => this.updateState("sneakers_condition", "vintage", true)}>Vintage</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "pre_order"))} onClick={() => this.updateState("sneakers_condition", "pre_order", true)}>Pre-Order</Button>
                </div>
              </Row>

              :
              <Row className="condition-sneaker">
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "express_shipping"))} onClick={() => this.updateState("sneakers_condition", "express_shipping", true)}>Express Shipping <KickImage src={expressShippingIcon} alt="express shipping" style={{ width: "8px", height: "12px" }} /></Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "new"))} onClick={() => this.updateState("sneakers_condition", "new", true)}>Brand New</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "used"))} onClick={() => this.updateState("sneakers_condition", "used", true)}>Used</Button>
                </div>
                <div className="condition-button">
                  <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", "pre_order"))} onClick={() => this.updateState("sneakers_condition", "pre_order", true)}>Pre-Order</Button>
                </div>
              </Row>
          }
        </Col>
      </Row>
    )
  }

  _renderNewGender = () => {
    return (
      <Row style={{ alignSelf: "flex-start" }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Gender</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="condition-wrapper">
          <Row className="condition-sneaker">
            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("sex", "M"))} onClick={() => this.updateState("sex", "M", true)}>Men</Button>
            </div>

            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("sex", "F"))} onClick={() => this.updateState("sex", "F", true)}>Women</Button>
            </div>
            <div className="condition-button">
              <Button block className={classNames("flat spacer", this.getButtonClass("sex", "Y"))} onClick={() => this.updateState("sex", "Y", true)}>Youth</Button>
            </div>
          </Row>
        </Col>
      </Row>
    )
  }

  _toggle = (tabs) => {
    if (this.state._tabs !== tabs)
      this.setState({
        _activeTabSize: tabs
      })
  }

  _renderNewApparelsSize = () => {
    let { activeApparelsSize } = this.state
    const { apparelsSizes } = this.props.dataFilter.sizes;
    let topSizes = [];
    let bottomSizes = [];
    let otherSizes = [];
    apparelsSizes
      .filter(s => s.US === undefined) //filter not containing sneaker's sizes..
      .map(s => {
        if (s.alias == 'TOP')
          topSizes.push({ ...s.size, alias: s.alias })
        else if (s.alias == 'BOTTOM')
          bottomSizes.push({ ...s.size, alias: s.alias })
        else {
          otherSizes.push({ ...s.size, alias: s.alias });
        }
      });

    if (otherSizes.length > 0) {
      const setAccessoriesSize = new Set();
      otherSizes = otherSizes.filter(el => {
        const duplicate = setAccessoriesSize.has(el.id);
        setAccessoriesSize.add(el.id);
        return !duplicate;
      });
    }

    let renderedSizes = [];
    switch (activeApparelsSize) {
      case "topSizes":
        renderedSizes = topSizes
        break;
      case "bottomSizes":
        renderedSizes = bottomSizes
        break;
      case "otherSizes":
        renderedSizes = otherSizes
        break;
    }

    return (
      <Row style={{ marginBottom: "10px", alignSelf: "flex-start" }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">US Size</p>
            </Col>
          </Row>
        </Col>

        <Col className="size-wrapper">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 1 })}
                onClick={() => { this._toggle(1); }}
              >
                Tops
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 2 })}
                onClick={() => { this._toggle(2); }}
              >
                Bottoms
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 3 })}
                onClick={() => { this._toggle(3); }}
              >
                Others
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state._activeTabSize}>
            {this.state.isFetchingSize ? <Loader isVisible={true} /> : <>
              <TabPane tabId={1}>
                <Row className="size-row">
                  {
                    topSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size, size.alias)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
              <TabPane tabId={2}>
                <Row className="size-row">
                  {
                    bottomSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size, size.alias)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
              <TabPane tabId={3}>
                <Row className="size-row">
                  {
                    otherSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size, size.alias)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
            </>}
          </TabContent>
        </Col>

      </Row>
    )
  }

  _renderNewSneakersSize = () => {

    let { activeSize } = this.state

    let femaleSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.femaleSizes.noDuplicate : []
    let maleSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.maleSizes.noDuplicate : []
    let kidSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.kidsSizes : []

    // femaleSizes = femaleSizes.filter(a=>a.brand_id && a.US).sort((a,b) => parseFloat(a.US) - parseFloat(b.US))
    // maleSizes = maleSizes.filter(a=>a.brand_id && a.US).sort((a,b) => parseFloat(a.US) - parseFloat(b.US))
    // kidSizes = kidSizes.sort((a,b) => {
    //   return parseFloat(a.US) !== parseFloat(b.US)
    //   ? parseFloat(a.US) - parseFloat(b.US)
    //   : (a.US > b.US) - (a.US < b.US)
    // })

    let renderedSizes = []

    switch (activeSize) {
      case "maleSizes":
        renderedSizes = maleSizes
        break;
      case "femaleSizes":
        renderedSizes = femaleSizes
        break;
      case "kidSizes":
        renderedSizes = kidSizes
        break;
    }

    return (
      <Row style={{ marginBottom: "10px", alignSelf: "flex-start" }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">US Size</p>
            </Col>
          </Row>
        </Col>

        <Col className="size-wrapper">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 1 })}
                onClick={() => { this._toggle(1); }}
              >
                Men
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 2 })}
                onClick={() => { this._toggle(2); }}
              >
                Women
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classNames({ active: this.state._activeTabSize === 3 })}
                onClick={() => { this._toggle(3); }}
              >
                Youth/Toddler
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state._activeTabSize}>
            {this.state.isFetchingSize ? <Loader isVisible={true} /> : <>
              <TabPane tabId={1}>
                <Row className="size-row">
                  {
                    maleSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
              <TabPane tabId={2}>
                <Row className="size-row">
                  {
                    femaleSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
              <TabPane tabId={3}>
                <Row className="size-row">
                  {
                    kidSizes.map(size => (
                      <Col xs={4} sm={2} key={size.id} className="size-column">
                        <Button
                          key={size.id}
                          onClick={() => this.selectSize(size)}
                          active={this.isSelectedSize(size)}
                        >
                          {size.US}
                        </Button>
                      </Col>
                    ))
                  }
                </Row>
              </TabPane>
            </>}
          </TabContent>
        </Col>

      </Row>

    )
  }

  handleChangeColor = (value) => {
    this.updateState("color", value, true)
  };

  _renderNewColor = () => {
    return (
      <Row style={{ marginBottom: "10px", alignSelf: "flex-start" }}>

        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Color</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12}>
          <Row>
            <Col>
              <ColorPicker
                onClick={this.handleChangeColor}
                isActive={this.state.color}
              />
            </Col>
          </Row>
        </Col>

      </Row>
    )
  }

  _renderNewPrice = () => {
    const auth = this.props.dataAuth
    const userCurrency = auth.isLogged && auth.userCurrency

    return (
      <Row style={{ marginBottom: 20 }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Price Range</p>
            </Col>
          </Row>
        </Col>
        <Col xs={12} style={{ marginBottom: 16 }}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{userCurrency ? userCurrency.currency : 'IDR'}</InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Minimum Price"
              name="startPrice"
              value={this.state.startPrice}
              onChange={this.onChangeHandler}
              inputMode='numeric'
            />
          </InputGroup>
        </Col>

        <Col xs={12}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{userCurrency ? userCurrency.currency : 'IDR'}</InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Maximum Price"
              name="endPrice"
              value={this.state.endPrice}
              onChange={this.onChangeHandler}
              inputMode='numeric'
            />
          </InputGroup>
        </Col>
      </Row>
    )
  }

  handleHotProductsFilter = () => {
    let { startPrice, endPrice, sneakers_condition, sex, color, searchCategory } = this.state;
    const { pathname } = this.props.history.location;
    const { isPreVerified } = this.props;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { params } = this.props.match;
    const currentCategory = (typeof params.category !== 'undefined' && params.category) ? searchCategory : "";
    const selectedCategory = categorySearch(currentCategory);

    let brands = this.state.selectedBrands?.join(",");
    let sizesParams = this.calculateSize();

    let filterQueries = '';
    if (brands?.length > 0) filterQueries += `brands=${brands}&`
    if (sizesParams) filterQueries += `${sizesParams}&`
    if (startPrice) filterQueries += `start_price=${startPrice || 0}&`
    if (endPrice) filterQueries += `end_price=${endPrice}&`
    if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    if (sizesParams) filterQueries += `${this.getSizeIdHelper()}`
    if (sex) filterQueries += `sex=${sex}&`
    if (color) filterQueries += `colours=${color}`

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    this.props.history.push({ pathname, search: newFilterQueries });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    const payload = {
      page: 1,
      availables: true,
      category: selectedCategory,
      sort_by: 'product_desc',
    }

    if (brands) payload.brands = brands
    if (sizesParams) payload.sizesParams = sizesParams
    if (startPrice) payload.start_price = startPrice
    if (endPrice) payload.end_price = endPrice
    if (sneakers_condition) payload.sneakers_condition = sneakers_condition
    if (sex) payload.sex = sex
    if (color) payload.colours = color

    this.props.getAdditionalPage('editors-choices', { params: payload });
  }

  handleMostPopularFilter = () => {
    let { startPrice, endPrice, sneakers_condition, sex, color, searchCategory } = this.state;
    const { pathname } = this.props.history.location;
    const { isPreVerified } = this.props;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { params } = this.props.match;
    const selectedCategory = (typeof params.category !== 'undefined' && params.category) ? searchCategory : "";

    let brands = this.state.selectedBrands?.join(",");
    let sizesParams = this.calculateSize();

    let filterQueries = '';
    if (brands?.length > 0) filterQueries += `brands=${brands}&`
    if (sizesParams) filterQueries += `${sizesParams}&`
    if (startPrice) filterQueries += `start_price=${startPrice || 0}&`
    if (endPrice) filterQueries += `end_price=${endPrice}&`
    if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    if (sizesParams) filterQueries += `${this.getSizeIdHelper()}`
    if (sex) filterQueries += `sex=${sex}&`
    if (color) filterQueries += `colours=${color}`

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    this.props.history.push({ pathname, search: newFilterQueries });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    const payload = {
      page: 1,
      availables: true,
      category: selectedCategory
    }

    if (brands) payload.brands = brands
    if (sizesParams) payload.sizesParams = sizesParams
    if (startPrice) payload.start_price = startPrice
    if (endPrice) payload.end_price = endPrice
    if (sneakers_condition) payload.sneakers_condition = sneakers_condition
    if (sex) payload.sex = sex
    if (color) payload.colours = color

    this.props.getAdditionalPage('trends', { params: payload })
  }

  handleBestSellingFilter = () => {
    let { startPrice, endPrice, sneakers_condition, sex, color, searchCategory } = this.state;
    const { pathname } = this.props.history.location;
    const { isPreVerified } = this.props;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { params } = this.props.match;
    const selectedCategory = (typeof params.category !== 'undefined' && params.category) ? searchCategory : "";

    let brands = this.state.selectedBrands?.join(",");
    let sizesParams = this.calculateSize();

    let filterQueries = '';
    if (brands?.length > 0) filterQueries += `brands=${brands}&`
    if (sizesParams) filterQueries += `${sizesParams}&`
    if (startPrice) filterQueries += `start_price=${startPrice || 0}&`
    if (endPrice) filterQueries += `end_price=${endPrice}&`
    if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    if (sizesParams) filterQueries += `${this.getSizeIdHelper()}`
    if (sex) filterQueries += `sex=${sex}&`
    if (color) filterQueries += `colours=${color}`

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    this.props.history.push({ pathname, search: newFilterQueries });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    const payload = {
      page: 1,
      availables: true,
      category: selectedCategory
    }

    if (brands) payload.brands = brands
    if (sizesParams) payload.sizesParams = sizesParams
    if (startPrice) payload.start_price = startPrice
    if (endPrice) payload.end_price = endPrice
    if (sneakers_condition) payload.sneakers_condition = sneakers_condition
    if (sex) payload.sex = sex
    if (color) payload.colours = color

    this.props.getAdditionalPage('top-selling', { params: payload })
  }

  handleCollectionFilter = () => {
    const { selected } = this.props.dataCategory;
    const { pathname } = this.props.history.location
    const { isPreVerified } = this.props;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { params } = this.props.match;
    const selectedCategory = (typeof params.category !== 'undefined' && params.category) ? selected : "";

    let brands = this.state?.selectedBrands ?? [].join(",")
    let sizesParams = this.calculateSize()
    let { startPrice, endPrice, sneakers_condition, sex, color } = this.state;

    let filterQueries = '';
    if (brands?.length > 0) filterQueries += `brands=${brands}&`
    if (sizesParams) filterQueries += `${sizesParams}&`
    if (startPrice) filterQueries += `start_price=${startPrice || 0}&`
    if (endPrice) filterQueries += `end_price=${endPrice}&`
    if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    if (sizesParams) filterQueries += `${this.getSizeIdHelper()}`
    if (sex) filterQueries += `sex=${sex}&`
    if (color) filterQueries += `colours=${color}`

    const newFilterQueriesUrl = filterQueries.replace('pre_verified', 'express_shipping');

    this.props.history.push({ pathname, search: newFilterQueriesUrl });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    const payload = {
      page: 1,
      availables: true,
      collection: slug,
      collection_type: collectionType,
      category: selectedCategory,
      sort_by: caseSorting
    }

    if (isPreVerified) payload.pre_verified = true

    this.props.fetchCollectionProduct(payload, filterQueries)
  }

  handleForYouFilter = () => {
    const { selected } = this.props.dataCategory;
    const { pathname } = this.props.history.location
    const { isPreVerified } = this.props;
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;

    let brands = this.state.selectedBrands ?? [].join(",")
    let sizesParams = this.calculateSize()
    let { minPrice, maxPrice } = this.state
    let { sneakers_condition } = this.state

    let filterQueries = '';
    if (brands) filterQueries += `brands=${brands}&`
    if (sizesParams) filterQueries += `${sizesParams}&`
    if (minPrice) filterQueries += `start_price=${minPrice || 0}&`
    if (maxPrice) filterQueries += `end_price=${maxPrice}&`
    if (sneakers_condition) filterQueries += `sneakers_condition=${sneakers_condition}&`
    if (sizesParams) filterQueries += `${this.getSizeIdHelper()}`

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    if (filterQueries)
      this.props.history.push({ pathname, search: newFilterQueries });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    const payload = {
      page: 1,
      availables: true,
      collection: slug,
      collection_type: collectionType,
      category: selected,
      sort_by: caseSorting
    }

    this.props.getRecommendedProduct(userdata.id, selected, filterQueries);
  }

  render() {
    const { selected } = this.props.dataCategory;
    const { searchCategory } = this.props;
    const { category } = this.props.match.params;
    if (!this.props.isOpen) return null;

    return (
      // <div id={'filter-dropdown'} className="container__drop_down show__option filter__dropdown__wrapper">
      <div id="filter-drawer__v3">
        <div className="drawer-content">
          <div onClick={() => this.props.onClose()} className='back-navigation'>
            <Row>
              <Col>
                <span><KickImage src={DrawerBack} alt="back to filter" /></span>
              </Col>
              <Col>
                <p>Filter</p>
              </Col>
            </Row>
          </div>
          {(!this.props.isForYou) && this._renderNewCategory()}
          {
            this.props.categoryOnly ? null
              : this.state.searchCategory !== '' &&
                (category === 'apparels' || category === 'streetwear' || category === 'fashion' || category === 'apparel') ?
                this._renderNewApparelsSize()
                : (
                  this.state.searchCategory !== '' && category === 'sneakers' ?
                    this._renderNewSneakersSize()
                    : null
                )
          }
          {(!this.props.isForYou && !this.props.categoryOnly) && this._renderNewConditions()}
          {(!this.props.isForYou && !this.props.categoryOnly) && this._renderNewPrice()}
          {!["lifestyle", "toys", "electronics-collectibles"].includes(category) && !this.props.categoryOnly && this._renderNewGender()}
          {!["lifestyle", "toys", "electronics-collectibles"].includes(category) && !this.props.categoryOnly && this._renderNewColor()}
          {(category !== "" && !this.props.isForYou && !this.props.categoryOnly) && this._renderAllBrands()}

        </div>
        <Row className="action-button">
          <Col className="button-filter reset" lg={6} md={6} sm={6} xs={6}>
            <Button
              block
              size="lg"
              className="btn-black flat spacer"
              onClick={this.resetFilter}
              disabled={(searchCategory === "") && (this.state.selectedBrands ?? [].length === 0) && (this.state.startPrice === "") && (this.state.endPrice === "") && (this.state.sex === "") && (this.state.color === "") && (this.state.sneakers_condition === "")}
            >Clear Filters</Button>
          </Col>
          <Col className="button-filter apply" lg={6} md={6} sm={6} xs={6}>
            <Button
              block
              size="lg"
              className="btn-black flat spacer"
              onClick={this.applyFilter}
              disabled={(searchCategory === "") && (this.state.selectedBrands ?? [].length === 0) && (this.state.startPrice === "") && (this.state.endPrice === "") && (this.state.sex === "") && (this.state.color === "") && (this.state.sneakers_condition === "")}
            >Apply Filter</Button>
          </Col>
        </Row>
      </div>
      // </div>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct,
  dataFilter: state.filterReducer,
  dataLocal: state.dataKaFair.local_brands
});
const mapDispatchToProps = {
  doFilteringSearchToApi,
  fetchCollectionProduct,
  getAllBrands,
  getAllSizes,
  getRecommendedProduct,
  getCollectionList,
  getAdditionalPage
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilterDrawer));